import { defineMessages } from 'react-intl';

export default defineMessages({
    claimDetailNumber: {
        id: 'claim.views.claim-detail.Claim Details',
        defaultMessage: 'Claim Details : { num }'
    },
    summaryTab: {
        id: 'claim.views.claim-detail.Summary',
        defaultMessage: 'Summary'
    },
    notesTab: {
        id: 'claim.views.claim-detail.Notes',
        defaultMessage: 'Notes'
    },
    documentsTab: {
        id: 'claim.views.claim-detail.Documents',
        defaultMessage: 'Documents'
    },
    paymentsTab: {
        id: 'claim.views.claim-detail.Financials',
        defaultMessage: 'Financials'
    },
    servicesTab: {
        id: 'claim.views.claim-detail.Repair',
        defaultMessage: 'Repair'
    },
    settlementLetterTab: {
        id: 'claim.views.claim-detail.Repair',
        defaultMessage: 'Repair'
    },
    policyNumberClaimDetail: {
        id: 'claim.views.claim-detail.Policy',
        defaultMessage: 'Policy'
    },
    policyStatus: {
        id: 'claim.views.claim-detail.Status',
        defaultMessage: 'Status'
    },
    reportedBy: {
        id: 'claim.views.claim-detail.Reported By',
        defaultMessage: 'Reported By'
    },
    accountNumber: {
        id: 'claim.views.claim-detail.Account',
        defaultMessage: 'Broker Account'
    },
    dateOfLossClaimDetail: {
        id: 'claim.views.claim-detail.Date of Loss',
        defaultMessage: 'Date of Loss'
    },
    totalPayments: {
        id: 'claim.views.claim-detail.Paid',
        defaultMessage: 'Paid'
    },
    totalIncurrednet: {
        id: 'claim.views.claim-detail.Net Incurred',
        defaultMessage: 'Net Incurred'
    },
    adjusterTitle: {
        id: 'claim.views.claim-detail.Adjuster',
        defaultMessage: 'Adjuster'
    },
    adjusterName: {
        id: 'claim.views.claim-detail.Name',
        defaultMessage: 'Name'
    },
    adjusterPhone: {
        id: 'claim.views.claim-detail.Phone',
        defaultMessage: 'Phone'
    },
    adjusterAddnoteButton: {
        id: 'claim.views.claim-detail.Add Note',
        defaultMessage: 'Add Note'
    },
    addnoteButton: {
        id: 'claim.views.claim-detail.Add Note',
        defaultMessage: 'Add Note'
    },
    addnoteButtonToolTip: {
        id: 'claim.views.claim-detail.NoteToolTip',
        defaultMessage: 'The information recorded here will directly transfer to the file. Please ensure the details are clear and professionally worded'
    },
    partiesInvolved: {
        id: 'claim.views.claim-detail.Parties Involved',
        defaultMessage: 'Parties Involved'
    },
    vendorsInvolved: {
        id: 'claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors Involved'
    },
    involvement: {
        id: 'claim.views.claim-detail.Involvement',
        defaultMessage: 'Involvement'
    },
    vehicle: {
        id: 'claim.views.claim-detail.Vehicle(s)',
        defaultMessage: 'Vehicle(s)'
    },
    make: {
        id: 'claim.directives.pa-vehicle-coverages.Make',
        defaultMessage: 'Make'
    },
    model: {
        id: 'claim.directives.pa-vehicle-coverages.Model',
        defaultMessage: 'Model'
    },
    year: {
        id: 'claim.directives.pa-vehicle-coverages.Year',
        defaultMessage: 'Year'
    },
    license: {
        id: 'claim.directives.pa-vehicle-coverages.Vehicle Reg. No.',
        defaultMessage: 'Vehicle Reg. No.'
    },
    coveragesFor: {
        id: 'claim.directives.pa-vehicle-coverages.Coverages for',
        defaultMessage: 'Coverages for {vehicleMake} {vehicleModel}'
    },
    type: {
        id: 'claim.directives.pa-vehicle-coverages.Type',
        defaultMessage: 'Type'
    },
    deductible: {
        id: 'claim.directives.pa-vehicle-coverages.Deductible',
        defaultMessage: 'Deductible'
    },
    limittype: {
        id: 'claim.directives.pa-vehicle-coverages.Limit Type',
        defaultMessage: 'Limit Type'
    },
    limitvalue: {
        id: 'claim.directives.pa-vehicle-coverages.Limit Value',
        defaultMessage: 'Limit Value'
    },
    perAccident: {
        id: 'claim.directives.pa-vehicle-coverages.Per Accident',
        defaultMessage: 'Per Accident'
    },
    perPerson: {
        id: 'claim.directives.pa-vehicle-coverages.Per Person',
        defaultMessage: 'Per Person'
    },
    lossLocation: {
        id: 'claim.views.claim-detail.Loss Location',
        defaultMessage: 'Loss Location'
    },
    incidentDesc: {
        id: 'claim.views.claim-detail.Incident description',
        defaultMessage: 'Incident description'
    },
    incidentCircumstance: {
        id: 'claim.views.claim-detail.Incident Circumstance',
        defaultMessage: 'Incident Circumstance'
    },
    liabilityStance: {
        id: 'claim.views.claim-detail.Liability Stance',
        defaultMessage: 'Liability Stance'
    },
    employerNotified: {
        id: 'claim.views.claim-detail.Date Employer Notified',
        defaultMessage: 'Date Employer Notified'
    },
    daysInHospital: {
        id: 'claim.views.claim-detail.Hospital',
        defaultMessage: 'Days spent in the hospital'
    },
    noNotes: {
        id: 'claim.views.claim-detail.No notes associated with this claim',
        defaultMessage: 'There are no notes associated with this claim.'
    },
    notesAuthor: {
        id: 'claim.directives.claim-notes.Author',
        defaultMessage: 'Author'
    },
    notesDate: {
        id: 'claim.directives.claim-notes.Date / Time',
        defaultMessage: 'Date / Time'
    },
    notesSubject: {
        id: 'claim.directives.claim-notes.Subject',
        defaultMessage: 'Subject'
    },
    notesContent: {
        id: 'claim.directives.claim-notes.Note',
        defaultMessage: 'Note'
    },
    searchPlaceholder: {
        id: 'claim.directives.claim-notes.Search',
        defaultMessage: 'Search'
    },
    createNoteSubject: {
        id: 'claim.views.create-note.Subject',
        defaultMessage: 'Subject'
    },
    createNoteCancel: {
        id: 'claim.views.create-note.Cancel',
        defaultMessage: 'Cancel'
    },
    createNoteSave: {
        id: 'claim.views.create-note.Save',
        defaultMessage: 'Save'
    },
    createArCancel:{
        id: 'claim.views.approved-repairer.Cancel',
        defaultMessage: 'Cancel'

    },
    createArSubmit:{
        id: 'claim.views.approved-repairer.Submit',
        defaultMessage: 'Submit'

    },
    documentsName: {
        id: 'claim.directives.claim-documents.Name',
        defaultMessage: 'Name'
    },
    documentsDateModified: {
        id: 'claim.directives.claim-documents.Date Uploaded',
        defaultMessage: 'Date Uploaded'
    },
    documentsViewandDownload: {
        id: 'claim.directives.claim-documents.View/Download',
        defaultMessage: 'View/Download'
    },
    documentsRemove: {
        id: 'claim.directives.claim-documents.Remove',
        defaultMessage: 'Remove'
    },
    uploadDocuments: {
        id: 'platform.documentupload.templates.document-upload.Upload Documents',
        defaultMessage: 'Upload Documents'
    },
    modalAddress: {
        id: 'platform.contacts.templates.contact-template.Address',
        defaultMessage: 'Address'
    },
    modalPrimary: {
        id: 'platform.contacts.templates.contact-template.primary',
        defaultMessage: 'primary'
    },
    modalPrimaryContact: {
        id: 'platform.contacts.templates.contact-template.Primary Contact',
        defaultMessage: 'Primary Contact'
    },
    modalPhoneNumber: {
        id: 'platform.contacts.templates.contact-template.Phone Number',
        defaultMessage: 'Phone Number'
    },
    modalTelephoneNumber: {
        id: 'platform.contacts.templates.contact-template.Telephone Number',
        defaultMessage: 'Telephone Number'
    },
    modalFaxNumber: {
        id: 'platform.contacts.templates.contact-template.Fax Number',
        defaultMessage: 'Fax Number'
    },
    modalClose: {
        id: 'platform.contacts.templates.contact-template.Close',
        defaultMessage: 'Close'
    },
    modalUnknown: {
        id: 'platform.contacts.Unknown',
        defaultMessage: 'Unknown'
    },
    claimServicesMessage: {
        id: 'claim.views.claim-detail.This tab contains claim-related services such as repairs, replacements or medical treatments.',
        defaultMessage: 'This tab contains claim-related services such as repairs, replacements or medical treatments.',
    },
    statusInProgress: {
        id: 'claim.views.claim-detail.In Progress',
        defaultMessage: 'In Progress',
    },
    statusCompleted: {
        id: 'claim.views.claim-detail.Completed',
        defaultMessage: 'Completed',
    },
    statusOffTrack: {
        id: 'claim.views.claim-detail.Off Track',
        defaultMessage: 'Off Track',
    },
    statusUnknown: {
        id: 'claim.controllers.ClaimDetailsCtrl.Unknown',
        defaultMessage: 'Unknown',
    },
    serviceNumber: {
        id: 'claim.views.claim-detail.Service Number',
        defaultMessage: 'Service Number',
    },
    nextAction: {
        id: 'claim.views.claim-detail.Next Action',
        defaultMessage: 'Next Action',
    },
    service: {
        id: 'claim.views.claim-detail.Service',
        defaultMessage: 'Service',
    },
    vendor: {
        id: 'claim.views.claim-detail.Vendor',
        defaultMessage: 'Vendor',
    },
    expectedCompletionDate: {
        id: 'claim.views.claim-detail.Expected Completion Date',
        defaultMessage: 'Expected Completion Date',
    },
    primaryContact: {
        id: 'claim.views.claim-detail.Primary Contact',
        defaultMessage: 'Primary Contact',
    },
    noClaimServices: {
        id: 'claim.views.claim-detail.There are no service requests associated with this claim.',
        defaultMessage: 'There are no service requests associated with this claim.',
    },
    paymentServicesMessage: {
        id: 'claim.directives.claim-payment-details.This tab lists payment transactions made based on the claim.',
        defaultMessage: 'This tab lists payment transactions made based on the claim.',
    },
    paymentStatus: {
        id: 'claim.directives.claim-payment-details.Status',
        defaultMessage: 'Status',
    },
    scheduledDate: {
        id: 'claim.directives.claim-payment-details.Scheduled Date',
        defaultMessage: 'Scheduled Date',
    },
    issueDate: {
        id: 'claim.directives.claim-payment-details.Issue Date',
        defaultMessage: 'Issue Date',
    },
    grossAmount: {
        id: 'claim.directives.claim-payment-details.Gross Amount',
        defaultMessage: 'Gross Amount',
    },
    checkNumber: {
        id: 'claim.directives.claim-payment-details.Check Number',
        defaultMessage: 'Check Number',
    },
    payee: {
        id: 'claim.directives.claim-payment-details.Payee',
        defaultMessage: 'Payee',
    },
    noClaimPayments: {
        id: 'claim.directives.claim-payment-details.There are no payments associated with this claim.',
        defaultMessage: 'There are no payments associated with this claim.',
    },
    confirmationToRemoveTitle: {
        id: 'claim.directives.ClaimDocuments.Remove Document',
        defaultMessage: 'Remove Document'
    },
    confirmationToRemoveMessage: {
        id: 'claim.directives.ClaimDocuments.Are you sure you want to remove',
        defaultMessage: 'Are you sure you want to remove {documentname}?'
    },
    removeConfirmationYes: {
        id: 'claim.directives.ClaimDocuments.Yes',
        defaultMessage: 'Yes'
    },
    removeConfirmationNo: {
        id: 'claim.directives.ClaimDocuments.No',
        defaultMessage: 'No'
    },
    deletionFailedTitle: {
        id: 'claim.directives.ClaimDocuments.Document deletion may have failed',
        defaultMessage: 'Document deletion may have failed'
    },
    deletionFailedMessage: {
        id: 'claim.directives.ClaimDocuments.Something may have gone wrong trying to delete your document.',
        defaultMessage: 'Something may have gone wrong trying to delete your document.'
    },
    removeServiceFailedTitle: {
        id: 'claim.directives.ClaimDocuments.Document deletion failed',
        defaultMessage: 'Document deletion failed'
    },
    removeServiceFailedMessage: {
        id: 'claim.directives.ClaimDocuments.Sorry your document could not be deleted at this time',
        defaultMessage: 'Sorry your document could not be deleted at this time'
    },
    noDocumentsMessage: {
        id: 'claim.directives.claim-documents.There are no documents associated with this claim.',
        defaultMessage: 'There are no documents associated with this claim.'
    },
    claimsTitle: {
        id: 'claim.views.claims.Claims',
        defaultMessage: 'Claims'
    },
    line: {
        id: 'claim.views.claims-list.Line',
        defaultMessage: 'Line'
    },
    claimNumber: {
        id: 'claim.views.claims-list.Claim Number',
        defaultMessage: 'Claim Number'
    },
    claimVendors: {
        id: 'claim.views.claims-list.Vendors',
        defaultMessage: 'Vendor(s)'
    },
    claimStatus: {
        id: 'claim.views.claims-list.Status',
        defaultMessage: 'Status'
    },
    includeClosedClaims: {
        id: 'claim.views.claims-list.Include Closed Claims',
        defaultMessage: 'Include Closed Claims'
    },
    allClaims: {
        id: 'claim.views.claims-list.All Claims',
        defaultMessage: 'All Claims'
    },
    openClaims: {
        id: 'claim.views.claims-list.Open Claims',
        defaultMessage: 'Open Claims'
    },
    closedClaims: {
        id: 'claim.views.claims-list.Closed Claims',
        defaultMessage: 'Closed Claims'
    },
    recentlyNotified: {
        id: 'claim.views.claims-list.Recently Notified',
        defaultMessage: 'Recently Notified'
    },
    recentlyClosed: {
        id: 'claim.views.claims-list.Recently Closed',
        defaultMessage: 'Recently Closed'
    },
    filters: {
        id: 'claim.views.claims-list.Filters',
        defaultMessage: 'Filters'
    },
    filterBy: {
        id: 'claim.views.claims-list.Filter By',
        defaultMessage: 'Filter By'
    },
    noClaimsResult: {
        id: 'claim.views.claims-list.There are no claims currently active',
        defaultMessage: 'There are no claims currently active'
    },
    noMatchingClaim:{
        id: 'claim.views.claims-list.No matching claims',
        defaultMessage: "We can’t find any records matching your chosen filters. Please try again with some alternative search criteria."
    },
    noClaimsRecentlyClosed: {
        id: 'claim.views.claims-list.There are no recently closed claims',
        defaultMessage: 'There are no recently closed claims'
    },
    noFilterSelected: {
        id: 'claim.views.claims-list.noFilterSelected',
        defaultMessage: 'Oops, you haven’t selected a claim filter. Please select one of the option from the drop down list and try searching again.'
    },
    serverCurrentlyUnavailable: {
        id: 'claim.views.claims-list.Server currently unavailable',
        defaultMessage: 'We apologize for the inconvenience, but the Allianz Claims Hub is currently offline. Please try again shortly. If this problem persists, please notify us on digitalsupport@allianz.co.uk'
    },
    serverTimeout: {
        id: 'claim.views.claims-list.Server timeout',
        defaultMessage: 'Sorry, it is taking a little longer than usual to find what you need. Please try searching again shortly. If this problem persists, please notify us on digitalsupport@allianz.co.uk'
    },
    fileclaim: {
        id: 'claim.views.claims-list.File a Claim',
        defaultMessage: 'File a Claim'
    },
    searchClaims: {
        id: 'claim.views.claims-list.Search Claims',
        defaultMessage: 'Search Claims'
    },
    searchByClaimNumber: {
        id: 'claim.views.claims-list.Search by claim number',
        defaultMessage: '__/_/__/______'
    },
    searchCriteria: {
        id: 'claim.views.claims-list.Search Criteria',
        defaultMessage: 'Select search filter'
    },
    pleaseCheckPolicyFormat: {
        id: 'claim.views.claims-list.Please check policy format',
        defaultMessage: 'Please ensure your Policy Number has the following format: XX00000000'
    },
    pleaseCheckClaimNumberFormat: {
        id: 'claim.views.claims-list.Please check claim number format',
        defaultMessage: 'Invalid Claim Number Format. Please check claim number is as follows: XX/0/XX/000000'
    },
    claimFormatShouldBe: {
        id: 'claim.views.claims-list.Claim format should be',
        defaultMessage: 'Please note you can only search using the full claim number. The format should be “XX/0/XX/000000” ',
    },
    unableToDeleteClaims: {
        id: 'claim.directives.ClaimDocuments.Unable to delete that document',
        defaultMessage: 'Unable to delete {documentName}'
    },
    loadingPolicyDetails: {
        id: 'claim.views.claim-policy-details.Loading policy details..',
        defaultMessage: 'Loading policy details..'
    },
    errorLoadingPolicyDetails: {
        id: 'claim.views.claim-policy-details.Error loading policy details...',
        defaultMessage: 'Error loading policy details...'
    },
    claimPolicyDetails: {
        id: 'claim.views.claim-policy-details.Policy Details',
        defaultMessage: 'Policy Details : {policyNumber}'
    },
    claimVehicleCoverage: {
        id: 'claim.views.claim-policy-details.Vehicle Coverages',
        defaultMessage: 'Vehicle Coverages'
    },

    policyLevelCoverages: {
        id: 'claim.directives.policy-level-coverages.Policy-Level Coverages',
        defaultMessage: 'Policy-Level Coverages'
    },
    limitType: {
        id: 'claim.directives.policy-level-coverages.Limit Type',
        defaultMessage: 'Limit Type'
    },
    limitValue: {
        id: 'claim.directives.policy-level-coverages.Limit Value',
        defaultMessage: 'Limit Value'
    },
    coverage: {
        id: 'claim.directives.policy-level-coverages.Coverage',
        defaultMessage: 'Coverage'
    },
    coveragePerAccident: {
        id: 'claim.directives.policy-level-coverages.Per Accident',
        defaultMessage: 'Per Accident'
    },
    coveragePerPerson: {
        id: 'claim.directives.policy-level-coverages.Per Person',
        defaultMessage: 'Per Person'
    },
    limit: {
        id: 'claim.directives.policy-level-coverages.Limit',
        defaultMessage: 'Limit'
    },
    insured: {
        id: 'claim.views.claim-detail.Insured',
        defaultMessage: 'Insured'
    },
    generateClaimSummary: {
        id: 'claim.views.claim-detail.Generate a claim summary',
        defaultMessage: 'Generate a claim summary'
    },
    generateSettlementLetterMessage: {
        id: 'claim.views.claim-detail.Click on the button to generate and receive an electronic copy of the claim summary (available on any closed claim only)',
        defaultMessage: 'Click on the button to generate and receive an electronic copy of the claim summary (available on any closed claim only)'
    }, 
    generateSettlementLetter: {
        id: 'claim.views.claim-detail.Generate Settlement Letter',
        defaultMessage: 'Generate Settlement Letter'
    },
    settLetterSuccess: {
        id: 'claim.views.claim-detail.Success Title',
        defaultMessage: 'Request successful'
    },
    settLetterFailure: {
        id: 'claim.views.claim-detail.Error Title',
        defaultMessage: 'Ooops, there was a problem.'
    },
    settSuccessContentOne: {
        id: 'claim.views.claim-detail.Success contentOne',
        defaultMessage: 'You’ve successfully requested a settlement letter be sent to {userName_Ext}.'
    },
    settSuccessContentTwo: {
        id: 'claim.views.claim-detail.Success contentTwo',
        defaultMessage: 'This will now be processed and should reach you within the next hour, if not sooner.'
    },
    settFailureContentOne: {
        id: 'claim.views.claim-detail.Error contentOne',
        defaultMessage: 'There was a problem with the request.Please try again now.'
    },
    settFailureContentTwo: {
        id: 'claim.views.claim-detail.Error contentTwo',
        defaultMessage: 'If the error persists contact one of our handlers via the chat function who will be happy to help.'
    },
    policyCover: {
        id: 'claim.views.claim-detail.Policy Cover',
        defaultMessage: 'Policy Cover'
    },
    liability: {
        id: 'claim.views.claim-detail.Liability',
        defaultMessage: 'Liability'
    },
    vehiclePP: {
        id: 'claim.views.claim-detail.Vehicle',
        defaultMessage: 'Vehicle'
    },
    thirdparty: {
        id: 'claim.views.claim-detail.Third Party',
        defaultMessage: 'Third Party'
    },
    recovery: {
        id: 'claim.views.claim-detail.Recovery',
        defaultMessage: 'Recovery'
    },
    docUploadSuccessTitle: {
        id: 'claim.views.claim-detail.Success DocUploadOne',
        defaultMessage: 'Document received and being uploaded'
    },
    docUploadSuccessContent: {
        id: 'claim.views.claim-detail.Success DocUploadTwo',
        defaultMessage: 'The document has been received and will be visible under the claim documents in a few hours once we have processed it'
    },
    docSupportMessage: {
        id: 'claim.directives.claim-documents.Please upload any supporting documents or images here',
        defaultMessage: 'Please upload any supporting documents or images here'
    },
    docUploadingMessage: {
        id: 'claim.directives.claim-documents.Uploading',
        defaultMessage: 'Uploading'
    },
    showFullStatusSummary: {
        id: 'claim.views.claim-detail.Show Full Status Overview',
        defaultMessage: 'Show Full Status Overview'
    },
    ownRepairSubmit: {
        id: 'claim.views.claim-detail.Submit',
        defaultMessage: 'Submit'
    },
    ownRepairCancel: {
        id: 'claim.views.claim-detail.Cancel',
        defaultMessage: 'Cancel'
    },
    ownRepairSubmitSuccessTitle: {
        id: 'claim.views.claim-detail.own repairer success',
        defaultMessage: 'Request Submission Successful'
    },
    brokerReferenceSubmitSuccessTitle: {
        id: 'claim.views.claim-detail.broker reference success',
        defaultMessage: 'Successful'
    },    
    ownRepairSubmitSuccessText: {
        id: 'claim.views.claim-detail.success updating own repairer',
        defaultMessage: 'Thank you for submitting your details in relation to your repair. \nIf you need to amend these details, please contact our claims team using our live chat function.'
    },
    arRepairSubmitSuccessText: {
        id: 'claim.views.claim-detail.success updating approved repairer',
        defaultMessage: 'Thank you for submitting your details. \nIf you need to amend these details, please contact our claims team using live chat, or phone 0370 606 4912.'
    },
    ownRepairSubmitErrorTitle: {
        id: 'claim.views.claim-detail.ooops, something went wrong',
        defaultMessage: 'Ooops, something went wrong...'
    },
    brokerReferenceSubmitErrorTitle: {
        id: 'claim.views.claim-detail.ooops, not able to update', 
        defaultMessage: 'something went wrong...'
    },    
    ownRepairSubmitErrorText: {
        id: 'claim.views.claim-detail.not able to update',
        defaultMessage: 'We were not able to update the repairer details. \nPlease try once more, failing which, use the chat facility to speak to a handler who will be happy to help.'
    },
    arepairSubmitErrorText: {
        id: 'claim.views.claim-detail.not able to update ar details',
        defaultMessage: 'We were not able to update the vehicle location or contact details. Please try again, failing which, please contact our claims team by live chat or phone 0370 606 4912 and we will be happy to help.'
    },
    ownRepairReasonChangePopupTitle: {
        id: 'claim.views.claim-detail.ca-own-repair-facility.popupHeader',
        defaultMessage: 'Manufacturer approved repairers in Allianz Network'
    },
    ownRepairReasonChangePopupText: {
        id: 'claim.views.claim-detail.ca-own-repair-facility.popupCopy',
        defaultMessage: 'Did you know that we can offer a manufacturer approved repairer within our network?'
    },
    ownRepairReasonChangePopupBtn: {
        id: 'claim.views.claim-detail.ca-own-repair-facility.popupButton',
        defaultMessage: 'Thanks, got it'
    }

});
